import { useState } from 'react';
import { Pin } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { repPost } from './reportsApi';
import { GREEN } from '../bfsi/bfsiShared';
import { typeLabel } from './PinnedReportsStrip';

export function PinButton({ type, filters, tenantName }) {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState('');
  const [saving, setSaving] = useState(false);

  const start = () => {
    setLabel(`${typeLabel(type)}${tenantName ? ` · ${tenantName}` : ''}`.slice(0, 60));
    setOpen(true);
  };

  const save = async () => {
    if (!label.trim()) return;
    setSaving(true);
    try {
      await repPost('/pins', { label: label.trim(), type, filters });
      toast.success('Pinned to dashboard');
      setOpen(false);
    } catch (e) { toast.error(e.message); }
    setSaving(false);
  };

  if (!open) {
    return (
      <Button data-testid="pin-report-btn" variant="outline" onClick={start} className="h-9 bg-white border-[#D9D6CD] gap-1.5">
        <Pin size={14} /> Pin to dashboard
      </Button>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid="pin-report-form">
      <Input data-testid="pin-label-input" autoFocus value={label} maxLength={60} onChange={e => setLabel(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setOpen(false); }}
        placeholder="Pin label" className="h-9 w-56 bg-white border-[#D9D6CD]" />
      <Button data-testid="pin-save-btn" onClick={save} disabled={saving || !label.trim()} className="h-9 text-white" style={{ background: GREEN }}>
        {saving ? 'Saving…' : 'Save pin'}
      </Button>
      <Button data-testid="pin-cancel-btn" variant="ghost" onClick={() => setOpen(false)} className="h-9">Cancel</Button>
    </div>
  );
}
